import * as yup from 'yup';

export const blindAuctionSchema = yup.object().shape({
  amount: yup
    .string()
    .test({
      name: 'amount',
      test: (value, context) => {
        const balance = context.options.context?.balance;

        if (!value) {
          return context.createError({
            type: 'CUSTOM',
            message: 'Required'
          });
        }

        if (+value > +balance) {
          return context.createError({
            type: 'CUSTOM',
            message: 'Insufficient balance'
          });
        }

        return true;
      }
    })
    .required(),
  token: yup
    .object()
    .shape({
      contractAddress: yup.string().required(),
      name: yup.string().required(),
      symbol: yup.string().required(),
      decimals: yup.number().required()
    })
    .required()
});
